/*
* (C) Behaviour Interactive Inc. - All Rights Reserved
* Unauthorized copying of this file, via any medium, is strictly prohibited
* This file is proprietary and confidential
*/

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Logout } from '@mui/icons-material';

import { LocalizedLink } from '../../_shared/LocalizedLink';
import { useAuth } from '../../authentication/AuthenticationContext';
import { MenuMotionSpan } from './MenuMotionSpan';
import { MenuLink } from './Menu.model';

interface Props {
  menuLinks: MenuLink[]
}

export function MenuMobile({ menuLinks }: Props): JSX.Element {
  const auth = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  const logout = (): void => {
    auth.logout();
  };

  return (
    <div className='account-menu-mobile'>
      <div className='nav-mobile'>
        <div className='menu-links'>
          {menuLinks.map((menuOption) => {
            if (menuOption.requires == null || menuOption.requires) {
              if ('isExternal' in menuOption) {
                return (
                  <a
                    key={menuOption.id}
                    className='menu-link'
                    href={menuOption.url}
                    target='_blank'
                    rel='noreferrer'
                  >
                    <div className='menu-link--text'>
                      <span>
                        {t(menuOption.translation)}
                      </span>
                    </div>
                  </a>
                );
              }
              const fullPath = `/account/${menuOption.path}`;
              return (
                <LocalizedLink key={menuOption.path} isNavLink className='menu-link' to={fullPath}>
                  {location.pathname.includes(fullPath) && (
                    <MenuMotionSpan id='menu-bar-mobile' />
                  )}
                  {t(menuOption.translation)}
                  {menuOption.notification && (
                    <div className='blink-alert menu-link--alert' />
                  )}
                </LocalizedLink>
              );
            }
            return null;
          })}
        </div>
      </div>

      <div className='text-center menu-header'>
        <h3>{t('auth.register.sign-up')}</h3>
        <h3 className='username' data-cy='mobile-nickname-text'>
          {auth.user.nickName}
        </h3>
        <button type='button' data-cy='mobile-logout-button' className='btn btn-secondary' onClick={logout}>
          <Logout className='icon' />
          {t('button.logout')}
        </button>
      </div>

    </div>
  );
}
